import type { AttributeChangeProps } from '../../../types';
import { NumberField } from '@flos/react-ui';
import { useHippoText } from '../../../../../hooks/useHippoText';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import { isOpcFetchingAtom } from '../../../../../recoil/atoms/isOpcFetchingAtom';
import { getOPCReceiptPageChangeTypeAtom } from '../../../../../recoil/atoms/getOPCReceiptPageChangeTypeAtom';
import { getOPCCoverableAttributeSelector } from '../../../../../recoil/selectors/getOPCCoverableAttributeSelector';

const CarOdometerChange = ({
    updateCoverableAttribute
}: AttributeChangeProps): React.JSX.Element => {
    const getHippoText = useHippoText();
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);
    const currentOPCAttribute = useRecoilValue(getOPCCoverableAttributeSelector)?.car
        ?.odometerReading;
    const setOPCReceiptPageChangeType = useSetRecoilState(getOPCReceiptPageChangeTypeAtom);

    return (
        <>
            <p className="paragraph--small">{getHippoText('DSS-ODOMETER-STEP-SUBHEADER')}</p>
            <NumberField
                id="carOdometerReading"
                name="carOdometerReading"
                label={getHippoText('DSS-ODOMETER-STEP-INPUT-TEXT')}
                onBlur={(e) => {
                    updateCoverableAttribute({ odometerReading: e.target.value });
                    setOPCReceiptPageChangeType('updateMissingAttribute');
                }}
                onChange={(e) => {
                    const valueIsNotEmpty = e.target.value.length > 0;
                    setIsOpcDataFilled(valueIsNotEmpty);
                }}
                disabled={isOpcFetching}
                value={currentOPCAttribute}
            />
        </>
    );
};

export default CarOdometerChange;
